"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropzoneStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
const DropzoneStyled = (0, _styled.default)("div")`
    width: 100%;
    cursor: pointer;
    height: ${props => props.height}px;

    &[aria-disabled="true"] {
        cursor: not-allowed;
    }
`;
exports.DropzoneStyled = DropzoneStyled;
//# sourceMappingURL=DropzoneStyled.js.map